/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ro-mosaic-bg{overflow:hidden}  .ro-mosaic-bg .ro-mosaic-bg__images-blocks{width:50%;bottom:0;top:0;right:0;background-size:cover!important;background-position:left!important}  .ro-mosaic-bg .ro-mosaic-bg__logos{position:absolute;top:1vh;left:0;right:0;height:10vh}"];
export { styles as styles };
